export default {
  navigation: [
    { name: 'Главная', href: '/' },
    { name: 'Услуги', href: '/services' },
    { name: 'Портфолио', href: '/portfolio' },
    { name: 'О нас', href: '/about' },
    { name: 'Контакты', href: '/contact' }
  ],
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'it', name: 'Italiano', flag: '🇮🇹' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'pt', name: 'Português', flag: '🇵🇹' },
    { code: 'ro', name: 'Română', flag: '🇷🇴' }
  ],
  contact: {
    phone: '+41 77 218 45 02',
    email: 'info@alpbuild.ch',
    address: 'Швейцария, кантоны Во и Женева',
    whatsapp: '+41772184502',
    workingHours: 'Пн-Пт: 7:00-17:00'
  }
};